import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppSelectSync from '@nxsys/components/AppSelectSync';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Option } from '@nxsys/types/models/Common';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import React, { useState } from 'react';
import { useEmployerFieldLabels } from '@nxsys/hooks/useEmployerFieldLabels';

type SyncPensionModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: SyncPensionValues) => Promise<void>;
};

export type SyncPensionValues = {
  company: Option<string> | null;
};

const SyncPensionModal: React.FC<SyncPensionModalProps> = ({
  isOpen,
  toggle,
  onSubmit,
}: SyncPensionModalProps) => {
  const { messages } = useTypedIntl();
  const employerLabels = useEmployerFieldLabels();

  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onFinish: FormProps['onFinish'] = (values) => {
    setIsSubmitting(true);
    onSubmit(values)
      .then(() => {
        toggle();
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppModalContainer
      title={messages['common.syncPensionData']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.syncData'],
          buttonType: 'primary',
          onClick: () => form.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <Form.Item
          label={employerLabels.label}
          name="company"
          rules={[
            {
              required: true,
              message: messages['form.pleaseSelect'],
            },
          ]}
        >
          <AppSelectSync
            type="company"
            apiType="searchCompany"
            placeholder={messages['form.selectCompany']}
            style={{ width: '100%' }}
            onChangeValue={(value: any) => {
              form.setFieldValue('company', value);
            }}
            paramFilter={{ enableAsyncPension: true }}
          />
        </Form.Item>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default SyncPensionModal;
